<mat-sidenav-container class="sidebar-container">
  <mat-sidenav mode="side" class="sidebar" opened fixedInViewport="true">
    <div class="sidebar-group sidebar-header">
      <app-hearhub-logo [inverted]="true" class="hearhub-logo" />
      <app-clinician-portfolio class="clinician-portfolio" />
    </div>
    <div class="sidebar-group">
      <app-sidebar-primary-button
        id="dashboard-button"
        *ngIf="hasTools"
        link="dashboard"
        icon="home"
        >{{ 'Dashboard' | translate }}</app-sidebar-primary-button
      >
      <app-sidebar-primary-button
        id="courses-button"
        link="courses"
        icon="bar_chart"
        [rotate]="true"
        >{{ 'Courses' | translate }}</app-sidebar-primary-button
      >
      <app-sidebar-primary-button
        id="reporting-button"
        *ngIf="hasTools"
        link="reporting/flip/population"
        icon="bid_landscape"
        >{{ 'Reporting' | translate }}</app-sidebar-primary-button
      >
      <app-sidebar-primary-button
        id="faq-button"
        link="faqs-and-forms"
        icon="library_books"
        >{{ 'FAQs & Forms' | translate }}</app-sidebar-primary-button
      >
      <mat-form-field appearance="fill" class="language-button-select">
        <mat-select
          [(value)]="selectedLanguage"
          disableRipple
          (selectionChange)="onLanguageChange($event.value)"
          class="compact-select"
        >
          <mat-option *ngFor="let option of languages" [value]="option.code">
            {{ option.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="sidebar-group sidebar-footer">
      <app-sidebar-secondary-button
        *ngIf="false"
        id="support-button"
        link="{{ supportLink }}"
        >{{ 'Support & Feedback' | translate }}</app-sidebar-secondary-button
      >
      <app-sidebar-secondary-button
        id="about-button"
        link="{{ aboutHearHubFeatureLink }}"
        >{{ 'About HearHub' | translate }}</app-sidebar-secondary-button
      >
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="content-container">
      <ng-content />
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
